import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

import { isHarnessError } from '../errors';

/**
 * Confirms removing one Harness.
 *
 * Mirrors `llm-profiles/components/LlmProfileDeleteDialog.tsx`: a blocked
 * delete (default harness, or referenced by an LLM Profile — FR-009/FR-009b)
 * is a recoverable refusal the admin needs to read, so this dialog stays open
 * and renders the mapped message rather than just toasting and closing.
 */
export function HarnessDeleteDialog({
  name,
  open,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  name: string;
  open: boolean;
  isPending: boolean;
  error: unknown;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const serverError = isHarnessError(error) ? error : undefined;
  const message =
    serverError?.message ??
    (error ? 'The request failed. Please try again.' : null);

  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{name}&rdquo;?</>}
      confirmLabel="Delete harness"
      isPending={isPending}
      error={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      This removes the &ldquo;{name}&rdquo; Harness. Any LLM Profile still
      referencing it must be reassigned first.
    </ConfirmDestructiveDialog>
  );
}
